var _rect, _rect2, _path, _path2, _g, _path3, _path4, _g2, _g3, _ellipse, _circle, _circle2, _circle3, _circle4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCharacterBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 69,
    viewBox: "0 0 62 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60.9833,
    y: 43.1675,
    width: 6.62798,
    height: 21.1462,
    rx: 3.31399,
    transform: "rotate(145.994 60.9833 43.1675)",
    fill: "#ADB5FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.62798,
    height: 21.1462,
    rx: 3.31399,
    transform: "matrix(0.828978 0.559281 0.559281 -0.828978 1 43.1675)",
    fill: "#ADB5FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1157 52.8072C29.1481 52.8072 29.174 52.8294 29.2064 52.8406V43.6851L20.0397 45.7233C20.0397 45.7233 20.1369 49.566 20.2535 52.8517C20.2859 52.8517 20.3183 52.8183 20.3572 52.8183H29.1157V52.8072Z",
    fill: "#ADB5FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2289 53.8982C20.2684 54.3754 20.3013 54.7333 20.3343 54.8876C20.4067 55.428 20.1235 55.5683 19.8205 55.456C18.6415 54.8666 17.5876 54.9227 16.6326 55.456C15.2757 56.3262 15.0452 58.9156 16.1913 59.9612C16.8433 60.6208 17.5415 60.9366 18.2595 60.9997H27.349C28.6071 60.9506 29.1735 60.1436 29.2065 58.7682V53.8701C29.2065 53.8701 29.1472 53.8912 29.1142 53.8912H20.2289V53.8982Z",
    fill: "#A6E7BC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_681_698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4558 52.3662C29.4558 52.3662 29.3962 52.3428 29.363 52.3428H20.3991C20.3593 52.3428 20.3328 52.3662 20.293 52.3662C19.8687 52.4286 19.5305 52.8423 19.5305 53.3574C19.5305 53.9193 19.9151 54.3798 20.3991 54.3798H29.363C29.3962 54.3798 29.4227 54.3642 29.4558 54.3564C29.8868 54.3018 30.2249 53.8803 30.2249 53.3574C30.2249 52.8345 29.8868 52.4208 29.4558 52.3584V52.3662Z",
    fill: "#A6E7BC"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8619 52.7977C32.8295 52.7977 32.8036 52.8249 32.7712 52.8385V41.6484L41.9379 44.1397C41.9379 44.1397 41.8407 48.8362 41.7241 52.8521C41.6917 52.8521 41.6593 52.8113 41.6204 52.8113H32.8619V52.7977Z",
    fill: "#ADB5FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7489 53.8982C41.7093 54.3754 41.6764 54.7333 41.6435 54.8876C41.571 55.428 41.8542 55.5683 42.1572 55.456C43.3362 54.8666 44.3901 54.9227 45.3452 55.456C46.702 56.3262 46.9325 58.9156 45.7865 59.9612C45.1344 60.6208 44.4362 60.9366 43.7183 60.9997H34.6287C33.3706 60.9506 32.8042 60.1436 32.7713 58.7682V53.8701C32.7713 53.8701 32.8305 53.8912 32.8635 53.8912H41.7489V53.8982Z",
    fill: "#A6E7BC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_681_698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5218 52.3662C32.5218 52.3662 32.5814 52.3428 32.6146 52.3428H41.5785C41.6183 52.3428 41.6448 52.3662 41.6846 52.3662C42.1089 52.4286 42.4471 52.8423 42.4471 53.3574C42.4471 53.9193 42.0625 54.3798 41.5785 54.3798H32.6146C32.5814 54.3798 32.5549 54.3642 32.5218 54.3564C32.0908 54.3018 31.7527 53.8803 31.7527 53.3574C31.7527 52.8345 32.0908 52.4208 32.5218 52.3584V52.3662Z",
    fill: "#A6E7BC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_681_698)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3521 7.7343C25.7814 4.9807 28.9236 5.77301 30.1594 8.24465C30.4498 8.82548 31.3791 9.63865 32.7731 8.24465C33.9348 6.7926 38.8719 3.88843 44.9706 11.7297L44.9185 11.6455C48.7007 16.5622 50.7417 23.759 51.564 34.4212C52.269 43.5806 52.1214 44.7446 49.9248 47.3274C46.8041 50.9968 43.5155 50.9274 40.2779 47.1205L37.6885 44.0759L35.736 47.1205C33.3441 50.8486 28.9793 51.0662 26.0346 47.6037C23.888 45.0796 23.8289 45.0796 21.8855 47.6037C19.2904 50.9754 15.1765 50.854 12.1682 47.3167C10.0023 44.7699 9.81723 43.4765 10.4155 35.0833C11.2476 23.4091 15.7543 12.0927 21.2861 7.78528C21.308 7.76822 21.33 7.75122 21.3521 7.7343Z",
    fill: "#ADB5FA"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.4796,
    cy: 30.1897,
    rx: 12.9861,
    ry: 12.4768,
    fill: "url(#paint0_radial_681_698)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6104,
    cy: 24.5582,
    r: 1.98839,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.331399,
    cy: 0.331399,
    r: 0.331399,
    transform: "matrix(-1 0 0 1 27.9361 23.8955)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.9012,
    cy: 24.5582,
    r: 1.98839,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.331399,
    cy: 0.331399,
    r: 0.331399,
    transform: "matrix(-1 0 0 1 35.2267 23.8955)",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7481 21.1692C25.5207 21.2511 25.3888 21.3469 25.3376 21.4205C25.2587 21.5339 25.1029 21.5619 24.9896 21.483C24.8762 21.4042 24.8483 21.2484 24.9271 21.135C25.0669 20.9341 25.3169 20.793 25.5788 20.6987C25.8498 20.6012 26.1729 20.5397 26.5044 20.5231C27.1522 20.4906 27.9118 20.628 28.3685 21.1049C28.464 21.2046 28.4605 21.3628 28.3608 21.4583C28.2611 21.5538 28.1028 21.5504 28.0073 21.4507C27.7001 21.1299 27.1229 20.9927 26.5294 21.0224C26.2402 21.0369 25.9666 21.0906 25.7481 21.1692Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.313 21.1635C33.1328 21.2413 33.029 21.3316 32.9875 21.4031C32.9183 21.5226 32.7653 21.5633 32.6458 21.494C32.5264 21.4248 32.4857 21.2718 32.5549 21.1524C32.6726 20.9494 32.8871 20.8027 33.1147 20.7044C33.3482 20.6036 33.6258 20.5403 33.91 20.5232C34.4672 20.4897 35.1227 20.6328 35.5129 21.1218C35.599 21.2297 35.5814 21.387 35.4735 21.4732C35.3655 21.5593 35.2082 21.5416 35.1221 21.4337C34.8758 21.125 34.4172 20.9936 33.94 21.0223C33.707 21.0363 33.4873 21.0882 33.313 21.1635Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.029 28.729V29.4425C29.029 29.8676 30.3869 29.8676 30.3869 29.4425V28.729H29.029Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7288 28.729V29.4425C30.7288 29.8676 32.0867 29.8676 32.0867 29.4425V28.729H30.7288Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0179 27.834C28.156 27.834 28.2679 27.9459 28.2679 28.084C28.2679 28.1396 28.2929 28.2065 28.3913 28.2867C28.4932 28.3699 28.6549 28.4496 28.8743 28.517C29.311 28.6511 29.9095 28.7163 30.521 28.7097C31.1319 28.7031 31.7323 28.6251 32.1714 28.4871C32.3923 28.4176 32.5563 28.338 32.6601 28.2568C32.7629 28.1765 32.7794 28.118 32.7794 28.084C32.7794 27.9459 32.8914 27.834 33.0294 27.834C33.1675 27.834 33.2794 27.9459 33.2794 28.084C33.2794 28.3283 33.1393 28.5169 32.9681 28.6507C32.7978 28.7839 32.5702 28.8858 32.3213 28.9641C31.8208 29.1213 31.1683 29.2028 30.5264 29.2097C29.8849 29.2166 29.2305 29.1494 28.7276 28.995C28.4772 28.9181 28.2473 28.8145 28.0752 28.6741C27.8995 28.5308 27.7679 28.3338 27.7679 28.084C27.7679 27.9459 27.8798 27.834 28.0179 27.834Z",
    fill: "#010101"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_681_698",
    x: 13.5305,
    y: 46.3428,
    width: 30.6945,
    height: 22.0371,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_681_698"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_681_698",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_681_698",
    x: 25.7526,
    y: 46.3428,
    width: 30.6945,
    height: 22.0371,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_681_698"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_681_698",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_681_698",
    x: 0.120605,
    y: 0,
    width: 61.8199,
    height: 64.0649,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_681_698"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_681_698",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_681_698",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.4796 30.1897) rotate(90) scale(12.4768 12.9861)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAD2FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacterBlue);
export default __webpack_public_path__ + "static/media/character_blue.0a2603d2e90e4c927fa5f6c7445859d6.svg";
export { ForwardRef as ReactComponent };